import React from 'react';
import { useNavigate } from 'react-router-dom';
import './RecipeCard.css';

const baseURL = process.env.REACT_APP_API_URL;

function RecipeCard({ recipe }) {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`/recipe/${recipe._id}`);
    };
    
    return (
        <div className="recipe-card" onClick={handleClick}>
        <img src={`${baseURL}/uploads/${recipe.image}`}  alt={recipe.title} className="recipe-image" />
        <div className="recipe-overlay">
            <h3 className="recipe-card-title">{recipe.title}</h3>
        </div>
        </div>
    );
}

export default RecipeCard;